const subscribeBody = {
  email: "",
  id: "",
  fields: [
    {
      name: "Email",
      value: "",
    },
    {
      name: "First Name",
      value: "",
    },
    {
      name: "Last Name",
      value: "",
    },
    {
      name: "Province",
      value: "",
    },
    {
      name: "Store Name",
      value: "",
    },
    {
      name: "Store Number",
      value: "",
    },
    {
      name: "Telephone",
      value: "",
    },
    {
      name: "Birth Date",
      value: "",
    },
    {
      name: "Pref_Groceries",
      value: "",
    },
    {
      name: "Pref_General Merchandise",
      value: "",
    },
    {
      name: "Pref_Home Furniture",
      value: "",
    },
    {
      name: "Pref_Contests",
      value: "",
    },
    {
      name: "Pref_Motorsports",
      value: "",
    },
    {
      name: "Pref_Toys",
      value: "",
    },
    {
      name: "Pref_Recipes",
      value: "",
    }
  ],
  subscriptionPermissions: [
    {
      name: "Promotional Email Communications",
      permission: "Unassigned",       
    },
    {
      name: "DO NOT USE_eFlyers",
      permission: "Unassigned",       
    },
  ],
};

export default subscribeBody;
